import React, { Fragment } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import Img from "gatsby-image"

import media from "../../styles/media"

const NewsContent = styled(Link)`
  grid-column-end: span 2;
  color: ${props => props.theme.black};
  text-decoration: none;

  p {
    margin: 0;
  }

  &:hover {
    color: ${props => props.theme.red};
  }

  ${media.tablet`
    align-self: center;
    grid-column: auto / span 3;
  `}
`

const Date = styled.p`
  color: ${props => props.theme.lightGrey};
  font-size: 12px;
  letter-spacing: 1.33px;
  line-height: 19px;
  text-transform: uppercase;
  white-space: pre;
  margin-bottom: 0;
  ${media.tablet`
    font-size: 16px;
    line-height: 30px;
  `};
`

const NewsText = styled.p`
  margin-top: 0;
  font-family: StanleyRegular, serif;
  font-size: 16px;

  ${media.tablet`
    font-size: 20px;
  `}
`

const NewsImage = styled.div`
  grid-column-end: span 2;
  align-self: center;

  img {
    height: 100%;
    vertical-align: bottom;
    width: 100%;
  }

  ${media.tablet`
    grid-column: 1 / span 3;
  `};
`

export const NewsItem = ({ relatedArticles }) =>
  relatedArticles.map((article, i) => (
    <Fragment key={i}>
      <NewsImage>
        <Link to={`/news/${article.slug}`}>
          <Img alt={article.title} fluid={article.thumbnail.fluid} />
        </Link>
      </NewsImage>
      <NewsContent to={`/news/${article.slug}`}>
        <Date>{article.date}</Date>
        <NewsText>{article.title}</NewsText>
      </NewsContent>
    </Fragment>
  ))
